import { render, staticRenderFns } from "./ReportProjectByDepartment.vue?vue&type=template&id=2aa3a8cd&scoped=true"
import script from "./ReportProjectByDepartment.vue?vue&type=script&lang=js"
export * from "./ReportProjectByDepartment.vue?vue&type=script&lang=js"
import style0 from "./ReportProjectByDepartment.vue?vue&type=style&index=0&id=2aa3a8cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa3a8cd",
  null
  
)

export default component.exports